// Generated by ReScript, PLEASE EDIT WITH CARE

import * as OnError$LiteracyplanetClientFlags from "./OnError.res.mjs";

function MapResult(props) {
  var __onOk = props.onOk;
  var result = props.result;
  var onOk = __onOk !== undefined ? __onOk : (function (param) {
        return null;
      });
  var onError = OnError$LiteracyplanetClientFlags.use();
  if (result.TAG === "Ok") {
    return onOk(result._0);
  } else {
    return onError(result._0);
  }
}

var make = MapResult;

export {
  make ,
}
/* OnError-LiteracyplanetClientFlags Not a pure module */
